var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"time-picker"}},[_c('van-picker',{ref:"timePicker",attrs:{"show-toolbar":"","cancel-button-text":"清空","columns":_vm.timeColumns},on:{"change":_vm.onChange,"confirm":_vm.selTime}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }